export const TerminationReasons = {
  NO_LONGER_NEEDED: 'NO_LONGER_NEEDED',
  TOO_EXPENSIVE: 'TOO_EXPENSIVE',
  SWITCHED_TO_COMPETITOR: 'SWITCHED_TO_COMPETITOR',
  MISSING_FEATURES: 'MISSING_FEATURES',
  OTHER_REASON: 'OTHER_REASON',
} as const;

export type TerminationReason = (typeof TerminationReasons)[keyof typeof TerminationReasons];
